import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycSubmittedPage from './KycSubmittedPage';

const KycSubmittedRoute: FuseRouteItemType = {
  path: '',
  element: <KycSubmittedPage />,
  auth: AUTH_ROLES.parent, // []
};

export default KycSubmittedRoute;
